<script>
export default {
    name: "privacyPolicy",
    data() {
        return {
            history: window.history.length,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="privacy_policy">
        <div class="banner flex align_center justify_center">
            <div class="layout_bg bg" :style="`background-image: url(${require('@/assets/images/privacyPolicy.jpg')});`"></div>
            <p class="name text_shadow">隐私政策</p>
        </div>
        <!--  -->
        <div class="main layout_main">
            <div class="top">
                <p class="title">隐私政策（Privacy Policy）</p>
                <p class="time">最后更新日期：2025年7月24日</p>
            </div>
            <!--  -->
            <div class="content">
                <p>奢颜（以下简称“本公司”或“Ambassador+”）非常重视您的隐私与个人信息保护。本隐私政策旨在说明我们如何收集、使用、存储和保护您在访问本网站时提供的信息。国及国际著作权法律的保护。</p>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">一、我们收集的信息</p>
                <p><b>我们可能收集以下信息（包括但不限于）：</b></p>
                <ul>
                    <li><p>您通过网站提交合作意向时提供的：姓名、公司名称、联系方式、合作项目简介等；</p></li>
                    <li><p>您浏览网站时自动采集的设备信息：浏览器类型、IP地址、访问页面、停留时长等匿名数据；</p></li>
                    <li><p>来自第三方服务工具的数据用于优化用户体验。</p></li>
                </ul>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">二、信息的使用方式供</p>
                <p><b>我们将所收集的信息用于以下目的：</b></p>
                <ul>
                    <li><p>与您联系并就合作事宜做出回应；</p></li>
                    <li><p>分析用户需求，以优化我们的服务和网站内容；</p></li>
                    <li><p>在获得您许可的前提下，向您发送有关项目、艺术家动态或公司资讯的通知。</p></li>
                </ul>
                <p><b>我们不会将您的信息出售或泄露给任何第三方，除非：</b></p>
                <ul>
                    <li><p>经您明确授权；</p></li>
                    <li><p>应法律法规或政府机关要求；</p></li>
                    <li><p>为了维护我们的合法权益。</p></li>
                </ul>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">三、信息安全</p>
                <p>我们采取合理的技术和管理措施来防止用户信息被非法访问、泄露、滥用或篡改。包括但不限于HTTPS加密、访问权限控制等。</p>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">四、用户权利</p>
                <p><b>您有权随时联系我司：</b></p>
                <ul>
                    <li><p>查询、更新、更正或删除您提交的个人信息；</p></li>
                    <li><p>撤回您对我们使用您的信息的授权。</p></li>
                </ul>
                <p>请发送邮件至：<b><a href="mailto:tinagao@supermediachina.com">tinagao@supermediachina.com</a></b></p>
            </div>
            <div class="content">
                <p class="h1">五、政策更新</p>
                <p>本隐私政策可能会根据法律法规或运营需求进行调整。变更将在本页面更新，并即时生效。</p>
                <p class="flex align_center"><img class="icon" src="@/assets/images/icon_terms_hands.png"/><b>合作须知（Partnership Guidelines）</b></p>
                <p>为了更高效地推进与奢颜签约艺人及艺术家的商业合作，请阅读以下合作须知：</p>
                <ol>
                    <li>
                        <div class="text">
                            <p><b>提案资料准备</b></p>
                            <p>请准备以下合作意向资料，并发送至：<b><a href="mailto:tinagao@supermediachina.com">tinagao@supermediachina.com</a></b></p>
                            <ul>
                                <li><p>品牌/公司简介</p></li>
                                <li><p>合作项目介绍（活动/产品/联名）</p></li>
                                <li><p>合作形式（定制 / 授权 / 出席 / 拍摄等）</p></li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>审核与匹配</b></p>
                            <p>收到需求后，我们将：</p>
                            <ul>
                                <li><p>初步审核是否符合签约艺人/艺术家的风格、调性及品牌契合度；</p></li>
                                <li><p>在3个工作日内回复是否进入商务对接流程。</p></li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>合同签署与执行</b></p>
                            <p>所有合作均需签署正式合同，明确权责、内容、交付与使用范围。未经授权使用签约艺术家或艺人资料、作品、形象，将被视为侵权。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>其他说明</b></p>
                            <ul>
                                <li><p>定制设计项目将预付定金；</p></li>
                                <li><p>授权合作请明确使用范围、渠道与期限；</p></li>
                                <li><p>奢颜保留对合作项目最终解释权。</p></li>
                            </ul>
                        </div>
                    </li>
                </ol>
            </div>
            <!--  -->
            <div class="bottom flex justify_between align_center">
                <div class="l">
                    
                </div>
                <div class="btn layout_flex_center" v-if="history > 2" @click="$router.go(-1)">返回</div>
                <router-link class="btn layout_flex_center" v-else to="/">返回</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main{
    padding: .6rem 0;
    font-size: .2rem;
    line-height: 1.8;
    .bottom{
        .p1{
            font-size: .2rem;
        }
        .p2{
            font-size: .16rem;
        }
        .btn{
            line-height: 1;
            height: .42rem;
            border: 1px solid #000;
            padding: 0 .14rem;
            cursor: pointer;
        }
    }
    .content{
        border-bottom: 2px solid #c9c9c9;
        padding-bottom: .3rem;
        margin-bottom: .3rem;
    }
    .top{
        margin-bottom: .6rem;
    }
    .icon{
        width: .31rem;
        margin-right: .1rem;
    }
    p{
        margin-bottom: .3em;
    }
    b{
        color: #000;
    }
    ul{
        list-style: disc;
        padding-left: .3rem;
    }
    ol{
        list-style: auto;
        padding-left: .3rem;
    }
    .title,
    .time{
        text-align: center;
    }
    .title{
        font-size: .32rem;
        font-weight: bold;
        margin-bottom: .1rem;
    }
    .time{
        font-size: .22rem;
    }
    .h1{
        font-size: .22rem;
    }
}
.banner{
    height: 5.36rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
        color: #fff;
    }
    .name{
        font-size: .36rem;
        font-weight: bold;
        color: #fff;
        margin-top: 1rem;
    }
}
</style>